<template>
  <div class="cusCase">
    <div class="contentcase">
      <div class="navs">
        <div v-for="(item, it) in caselist" :key="it" class="list">
          <el-card :body-style="{ padding: '0px' }">
            <img
              :src="item.img"
              alt=""
              class="imgtop"
              @click="tapcase(item.type)"
            />
            <div class="bottom clearfix" @click="tapcase(item.type)">
              <div @click="tapcase(item.type)">
                <p class="middlecolors fontw">
                  {{ item.name }}
                </p>
                <p class="colors" style="margin-top:10px;">
                  {{ item.title | ellipsisprot }}
                </p>
              </div>
              <div class="btn"></div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    caselist: Array
  },
  data() {
    return {
      selected: "0",
      img: require("../assets/img/main/caselogo.png"),
      imgs: require("../assets/img/main/logo.png")
    };
  },
  filters: {
    ellipsisprot(value) {
      if (!value) return "";
      if (value.length > 35) {
        return value.slice(0, 35) + "...";
      }
      return value;
    }
  },
  methods: {
    tapcase(type) {
      switch (type) {
        case 1:
          this.$router.push({
            path: "/product",
            query: {
              type: 1
            }
          });
          break;
        case 2:
          this.$router.push({
            path: "/product2",
            query: {
              type: 1
            }
          });
          break;
        case 3:
          this.$router.push({
            path: "/product3",
            query: {
              type: 1
            }
          });
          break;
        default:
          this.$router.push({
            path: "/product4",
            query: {
              type: 1
            }
          });
          break;
      }
    }
  }
};
</script>
<style lang="scss">
.cusCase {
  // 客户案例
  .contentcase {
    .navs {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .list {
        width: 590px;
        height: 360px;
        margin-bottom: 20px;
        cursor: pointer;
        .el-card {
          width: 100% !important;
          height: 100% !important;
        }
        .el-card__body {
          box-sizing: border-box;
          width: 100% !important;
          height: 100% !important;
        }
        .imgtop {
          width: 100%;
          vertical-align: middle;
        }
        .bottom {
          box-sizing: border-box;
          height: 100px;
          padding: 22px 16px 22px 22px;
          text-align: left;
          display: flex;
          justify-content: left;
        }
        .bottom:hover{
          background: #248f47;
        }
        .bottom:hover {
          .middlecolors {
            font-size: 16px !important;
            color: #fff !important;
          }
          .colors {
            font-size: 16px !important;
            color: #fff !important;
          }
        }
        .clearfix:before,
        .clearfix:after {
          display: table;
          content: "";
        }

        .clearfix:after {
          clear: both;
        }
      }
    }
  }
}
</style>
